module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Abbreviations")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "abbreviations"
    }
  }, [_c('p', {
    staticClass: "chap-ttl"
  }, [_c('a', {
    attrs: {
      "id": "pxi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Table_of_contents"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("AB    Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("ANF")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("The Ante-Nicene Fathers: Translation of the Writings of the Fathers Down to A.D. 325 ")]), _vm._v("(Grand Rapids: Eerdmans,1956–62 [1885–96])")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("ANRW")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Aufstieg und Niedergang der römischen Welt: Geschichte und Kultur Roms im Spiegel der neueren Forschung")]), _vm._v(", ed. H. Temporini and W. Haase (Berlin, 1972–)")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("AV")]), _vm._v("/KGB     Authorized Version/King James Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("BDAG    W. Bauer, F. W. Danker, W. F. Arndt and F. W. Gingrich, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("A Greek-English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v("(Chicago: University of Chicago Press, 3rd edn, 2000)")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("BDB     F. Brown, S. R. Driver and C. A. Briggs, "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Hebrew and English Lexicon of the Old Testament")]), _vm._v("  (Lafayette, IN: Associated Publishers, 1980)")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("BI")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Biblical Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("BZNW    Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("CBQ")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Catholic Biblical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("EKKNT    Evangelisch-katholischer Kommentar zum Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("EQ")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Evangelical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("ExGrT")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Expositor’s Greek Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("FRLANT    Forschungen zur Religion und Literatur des Alten und Neuen Testaments")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("HTR")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Harvard Theological Review")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("IB")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Interpreter’s Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("ICC    International Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Int")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("JAC     Jahrbuch für Antike und Christentum")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("JB     Jerusalem Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("JBL")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Journal of Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("JCE")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Journal of Christian Education")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("JPT")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Journal of Pentecostal Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("JRH")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Journal of Religious History")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("JSNT")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Journal for the Study of the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("JSNTMS    Journal for the Study of the New Testament Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("JSNTSup    Journal for the Study of the New Testament: Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("JSOT")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Journal for the Study of the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("JTS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Journal of Theological Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("LCC    Library of Christian Classics")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("LCL    Loeb Classical Library")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("LXX     Septuagint")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NCB    New Century Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NEB    New English Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("NIB")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("New Interpreter’s Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NICNT    New International Commentary on the New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NIGTC    New International Greek Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NIV    New International Version")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NJB    New Jerusalem Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NovTSup    Novum Testamentum: Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("NPNF")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Library of Nicene and Post-Nicene Fathers of the Christian Church")]), _vm._v(", ed. Philip Schaff (ser. i, 14 vols); ed. Philip Schaff with Henry Wace (ser. ii, 14 vols, Edinburgh: T & T Clark; repr. Grand Rapids: Eerdmans, 1991–)")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NRSV     New Revised Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("NTS")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("New Testament Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("PG     Patrologiae cursus completus: Series Graeca, ed. Jacques-Paul Migne (Paris: Garnier, 1844–65) (known as Patrologia Graeca)")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("PL     Patrologiae cursus completus: Series Latina, ed. Jacques-Paul Migne (Paris: Garnier, 1844–65) (known as Patrologia Latina)")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("REB     Revised English Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("RSV     Revised Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("RV    Revised Version")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("SBLDS    Society of Biblical Literature Dissertation Series")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("SBT    Studies in Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("SJT")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Scottish Journal of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("SNTSMS     Society for New Testament Studies Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("TDNT")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(", ed. G. Kittel and G. Friedrich (10 vols, Grand Rapids, Eerdmans, 1964–76)")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("TDOT")]), _vm._v(" "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Theological Dictionary of the Old Testament")]), _vm._v(", ed. G. J. Botterweck and H. Ringgren (15 vols, Grand Rapids: Eerdmans, 1974–)")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("UBS    United Bible Societies")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("WBC    Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("WUNT    Wissenschaftliche Untersuchungen zum Neuen Testament")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21effcc3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abbreviations.vue
// module id = 75
// module chunks = 0